import Immutable from 'seamless-immutable';
import { createReducer, completeReducer } from 'redux-recompose';

import { actions } from './actions';

const defaultState = {
  bills: [],
  billsLoading: false,
  billsError: null,
  billProgress: null,
  billProgressLoading: false,
  billProgressError: null,
  currentBill: null,
  currentBillLoading: true,
  currentBillError: null,
  paymentDocument: null,
  paymentDocumentLoading: false,
  paymentDocumentError: null,
  consumptionHistory: null,
  consumptionHistoryLoading: false,
  consumptionHistoryError: null,
  lastBill: {},
  pendingBillLoading: false,
  pendingBillError: null
};

const reducerDescription = {
  primaryActions: [
    actions.GET_BILLS,
    actions.GET_LAST_BILL,
    actions.GET_CURRENT_BILLS,
    actions.GET_PRINTED_BILL,
    actions.GET_PRINTED_BILL_PDF,
    actions.GET_BILL_PROGRESS,
    actions.GET_CONSUMPTION_HISTORY,
    actions.GET_PAYMENT_DOCUMENT,
    actions.GET_LAST_BILL_INFORMATION,
    actions.GET_MULTIPLE_BILLS
  ],
  override: {
    [actions.SET_DEFAULT_STATE]: (state, action) =>
      Immutable.merge(state, {
        [action.target]: defaultState[action.target]
      }),

    [actions.RESET_LAST_BILL_INFORMATION]: state =>
      Immutable.merge(state, {
        lastBillInformationLoading: false,
        lastBillInformation: null
      }),

    [actions.GET_PRINTED_BILL_SUCCESS]: (state, action) =>
      Immutable.merge(state, {
        [`${action.target}Loading`]: false,
        [action.target]:
          action.target === 'currentBill'
            ? {
                ...state[action.target],
                printedBill: action.payload.printedBill.url
              }
            : state[action.target].map(bill =>
                bill.id === action.payload.id
                  ? {
                      ...bill,
                      printedBill: action.payload.printedBill.url
                    }
                  : bill
              ),
        [`${action.target}Error`]: null
      }),

    [actions.APPEND_BILLS]: state =>
      Immutable.merge(state, {
        appendBillsLoading: true
      }),

    [actions.APPEND_BILLS_SUCCESS]: (state, action) =>
      Immutable.merge(state, {
        [action.target]: [...state[action.target], ...action.payload],
        error: null,
        appendBillsLoading: false
      }),

    [actions.APPEND_BILLS_FAILURE]: (state, action) =>
      Immutable.merge(state, {
        appendBillsLoading: false,
        [`${action.target}Error`]: {
          what: action.payload.error,
          where: action.type
        }
      })
  }
};

export const reducer = createReducer(Immutable(defaultState), completeReducer(reducerDescription));
